// src/App.tsx

import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/global.css";
import ResultsPage from "./pages/results";
import Screening from "./pages/screening"; // Public patient-facing Screening Form
import SendScreen from "./pages/sendscreen";
import { useEffect } from "react";
import { addRumSessionAttributes } from "./providers/RumProvider";
import { getFormContext } from "./utils/rum-tracking";
import { isResultsPath, RESULTS_PATH } from "./utils/routes";

function AppContent() {
  const location = useLocation();
  const isResultsPage = isResultsPath(location.pathname);
  
  useEffect(() => {
    // Extract URL parameters from current location
    const currentSearchParams = new URLSearchParams(location.search);
    
    // If we have URL parameters, store them in sessionStorage
    if (currentSearchParams.toString() && !isResultsPage) {
      sessionStorage.setItem("searchParams", `?${currentSearchParams.toString()}`);
    }

    // Add form context to RUM session attributes
    const formContext = getFormContext();
    if (formContext.formId) {
      // Delay adding attributes to ensure RUM is initialized
      setTimeout(() => {
        addRumSessionAttributes({
          formId: formContext.formId || "unknown",
          saxId: formContext.saxId || "unknown",
          practiceId: formContext.practiceId || "unknown",
          tenantId: formContext.tenantId || "unknown",
        });
      }, 1000);
    }
  }, [location.search, isResultsPage]);

  // Keep search params, if not present take them from session storage
  const searchParams = new URLSearchParams(
    location.search || sessionStorage.getItem("searchParams") || "",
  );
  
  // Check for required parameters - now more flexible to allow direct route access
  const ready =
    isResultsPage ||
    (searchParams.has("parentLocation") &&
      searchParams.has("redirectUri") &&
      searchParams.has("formId"));
  const shouldRedirectToRoot = !ready && !location.search;

  useEffect(() => {
    if (!shouldRedirectToRoot) return;
    console.error(
      "❌ Missing required query parameters in URL or sessionStorage",
    );
    // Redirect to the root with search params after a delay
    const timeoutId = setTimeout(() => {
      const searchParamsFromStorage = sessionStorage.getItem("searchParams");
      const storedParams = new URLSearchParams(searchParamsFromStorage || "");
      window.location.href = `${window.location.origin}/?${storedParams.toString()}`;
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [shouldRedirectToRoot]);

  if (shouldRedirectToRoot) {
    return null; // Prevent rendering if not ready
  }

  const params = searchParams.toString();
  
  // Render the application routes
  return (
    <main className="">
      <Routes>
        <Route element={<Screening />} path="/screening" />
        <Route element={<SendScreen />} path="/sendscreen" />
        <Route element={<ResultsPage />} path={RESULTS_PATH} />
        <Route
          element={<Navigate replace to={`/screening?${params}`} />}
          path="*"
        />
      </Routes>
    </main>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
